export default {
  tileTitle: {
    en: "Residence",
    ja: "住居"
  },

  residenceLabel: {
    en: "Residence",
    ja: "住居"
  },
  cityLabel: {
    en: "City",
    ja: "街"
  },
  postalCodeLabel: {
    en: "Postal code",
    ja: "郵便番号"
  },
  mainAddressLabel: {
    en: "Address №1",
    ja: "住所№1"
  },
  additionalAddressLabel: {
    en: "Address №2",
    ja: "住所№2"
  },
  region: {
    en: "Region",
    ja: "地域"
  },
}
